"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkWL32XBDWcjs = require('./chunk-WL32XBDW.cjs');


var _chunkR5F56AVKcjs = require('./chunk-R5F56AVK.cjs');


var _chunkDHMQIKTCcjs = require('./chunk-DHMQIKTC.cjs');


var _chunkWF6EZ2CWcjs = require('./chunk-WF6EZ2CW.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_2/router/CPIRouterV2_2.ts
var CPIRouterV2_2 = (_class = class extends _chunkDHMQIKTCcjs.CPIRouterV2_1 {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_2}
  async getPool(provider, params) {
    const poolAddress = await this.getPoolAddressByJettonMinters(
      provider,
      params
    );
    return _chunkWL32XBDWcjs.CPIPoolV2_2.create(poolAddress);
  }
  async getVault(provider, params) {
    const tokenMinter = provider.open(_chunkWF6EZ2CWcjs.JettonMinter.create(params.tokenMinter));
    const vaultAddress = await this.getVaultAddress(provider, {
      user: params.user,
      tokenWallet: await tokenMinter.getWalletAddress(this.address)
    });
    return _chunkR5F56AVKcjs.VaultV2_2.create(vaultAddress);
  }
}, _class.__initStatic(), _class);



exports.CPIRouterV2_2 = CPIRouterV2_2;
//# sourceMappingURL=chunk-OIHCOMFR.cjs.map